export enum OrderShippingMethodEnum {
  delivery = 'delivery',
  withdraw = 'withdraw',
}
